interface Props {
  title?: string;
  children?: any;
}

const PageHeader = ({ title, children }: Props) => {
  return (
    <div className="w-full flex flex-row items-center justify-between mb-5">
      {title && <div className="text-3xl">{title}</div>}
      {children && <div className="space-x-5">{children}</div>}
    </div>
  );
};

export default PageHeader;
